<template>
  <div class="changelog">
    <h2>Changelog</h2>
    <div class="scores">
      <strong>Version 1.4</strong>
      <p>You can press your score to toggle between current level and score</p>
      <p>See who the most adicted player is, check the highscore</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'changelog',
  data() {
    return {};
  },
};
</script>

<style lang="less">
.changelog {
  padding: 2rem;
  height: 100%;
  flex-direction: column;

  h2 {
    margin-bottom: 2rem;
  }

  strong {
    font-size: 1.3rem;
  }
  p {
    margin: 0 0 .5rem;
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// Changelog.vue?f27ddaa2